import { useInfiniteQuery } from "@tanstack/react-query";
import apiClient from "lib/api-client";

const getTrays = async ({ queryKey, pageParam = 1 }) => {
    const { limit, search } = queryKey;
    const payload = {
      pageNumber: pageParam,
      limit,
      searchTerm: search
    };
  
    const response = await apiClient.post("/api/v1/tray/getAllTray", payload);
  
    if (response.status !== 200) {
      throw new Error("Error fetching tray data");
    }
  
    return {
      trayData: response.data.trayData,
      currentPage: response.data.currentPage,
      totalPages: response.data.totalPages
    };
  };
  
  export const useTrays = ({ limit = 15, search }) => {
    return useInfiniteQuery({
      queryKey: ["trays", { limit, search }],
      queryFn: ({ pageParam = 1 }) => getTrays({ queryKey: { limit, search }, pageParam }),
      getNextPageParam: (lastPage) => {
        if (lastPage.currentPage < lastPage.totalPages) {
          return lastPage.currentPage + 1;
        }
        return undefined;
      },
      staleTime: 5 * 60 * 1000,
      retry: 1
    });
  };
  